<template>
  <div class="t-lk-modal__content t-lk-change-date">
    <h2 class="t-lk-modal__title">{{ $root.staticText.lk.actTitle }}</h2>
    <div class="t-lk-modal__text" v-html="$root.staticText.lk.actText"></div>

    <div class="t-lk-refuse-lead t-lk-modal__form">
      <div class="t-form__label t-lk-refuse-lead__label">
        {{ $root.staticText.lk.actRange }}
        <span>*</span>
      </div>

      <div class="t-lk-date t-filter__class t-act-date" @click="visibleDatePicker = !visibleDatePicker">
        <div class="t-lk-date__title t-lk-filter-item js-filter-date-item">
          <div class="t-lk-date__input">
            <input
              v-model="dateRangeText"
              :title="dateRangeText"
              class="t-lk-filter-item__input"
              :placeholder="$root.staticText.filter.choose2"
              readonly
            />
          </div>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.66683 1.8335C7.03502 1.8335 7.3335 2.13197 7.3335 2.50016V3.50016H12.6668V2.50016C12.6668 2.13197 12.9653 1.8335 13.3335 1.8335C13.7017 1.8335 14.0002 2.13197 14.0002 2.50016V3.50016H15.8335C16.4523 3.50016 17.0458 3.746 17.4834 4.18358C17.921 4.62116 18.1668 5.21466 18.1668 5.8335V15.8335C18.1668 16.4523 17.921 17.0458 17.4834 17.4834C17.0458 17.921 16.4523 18.1668 15.8335 18.1668H4.16683C3.54799 18.1668 2.9545 17.921 2.51691 17.4834C2.07933 17.0458 1.8335 16.4523 1.8335 15.8335V5.8335C1.8335 5.21466 2.07933 4.62117 2.51691 4.18358C2.9545 3.746 3.54799 3.50016 4.16683 3.50016H6.00016V2.50016C6.00016 2.13197 6.29864 1.8335 6.66683 1.8335ZM6.00016 4.8335H4.16683C3.90161 4.8335 3.64726 4.93885 3.45972 5.12639C3.27219 5.31393 3.16683 5.56828 3.16683 5.8335V15.8335C3.16683 16.0987 3.27219 16.3531 3.45972 16.5406C3.64726 16.7281 3.90161 16.8335 4.16683 16.8335H15.8335C16.0987 16.8335 16.3531 16.7281 16.5406 16.5406C16.7281 16.3531 16.8335 16.0987 16.8335 15.8335V5.8335C16.8335 5.56828 16.7281 5.31393 16.5406 5.12639C16.3531 4.93885 16.0987 4.8335 15.8335 4.8335H14.0002V5.8335C14.0002 6.20169 13.7017 6.50016 13.3335 6.50016C12.9653 6.50016 12.6668 6.20169 12.6668 5.8335V4.8335H7.3335V5.8335C7.3335 6.20169 7.03502 6.50016 6.66683 6.50016C6.29864 6.50016 6.00016 6.20169 6.00016 5.8335V4.8335ZM5.16683 9.16683C5.16683 8.79864 5.46531 8.50016 5.8335 8.50016H14.1668C14.535 8.50016 14.8335 8.79864 14.8335 9.16683C14.8335 9.53502 14.535 9.8335 14.1668 9.8335H5.8335C5.46531 9.8335 5.16683 9.53502 5.16683 9.16683Z"
              fill="#C0C0CC"
            />
          </svg>
        </div>
        <transition name="fade">
          <div v-if="visibleDatePicker" class="t-filter__date-picker js-date-picker t-lk-date-picker" @click.stop="">
            <div class="t-filter__date-picker-reset" @click="resetDate()" v-html="$root.staticText.filter.reset"></div>
            <v-date-picker
              v-model="dates"
              :first-day-of-week="1"
              @input="inputDate()"
              :locale="$router.history.base !== '' ? $router.history.base.substring(1) : 'ru'"
              no-title
              range
            >
            </v-date-picker>
          </div>
        </transition>
      </div>
    </div>
    <div class="t-act-date__btn t-btn _green _lk" :class="{ _disabled: disabledBtn }" @click="submit()">
      {{ $root.staticText.lk.actBtn }}
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'act-request',
  data() {
    return {
      visibleDatePicker: false,
      dates: ['', ''],
      disabledBtn: true,
      action: 'act-request',
    }
  },
  computed: {
    ...mapState('mobile', ['isMobile']),

    dateRangeText() {
      if (this.dates[1]) {
        return this.dates.join(' - ')
      }
      if (!this.dates[0] && !this.dates[1]) {
        return ''
      }
      return this.dates[0]
    },
  },
  methods: {
    ...mapActions('modal', ['modalType_lkSuccessOpen', 'modalType_lkErrorOpen', 'modalClose']),

    inputDate() {
      if (this.dates[1]) {
        this.visibleDatePicker = false
        this.disabledBtn = false
      } else {
        this.disabledBtn = true
      }
    },
    resetDate() {
      this.dates = ['', '']
      this.$router
        .push({
          name: this.$route.name,
          query: Object.assign({}, this.$route.query, { startDate: undefined, endDate: undefined }, this.objUndefined, {
            animation: this.animation,
          }),
        })
        .catch(() => {})
    },

    submit() {
      this.disabledBtn = true
      let fd = new FormData()
      fd.append('dateFrom', this.dates[0])
      fd.append('dateTo', this.dates[1])

      Vue.http
        .post(this.action, fd)
        .then(response => response.json())
        .then(data => {
          this.disabledBtn = false
          if (data.success) {
            this.modalClose()
            this.modalType_lkSuccessOpen({
              title: this.$root.staticText.lk.actSuccessTitle,
              text: this.$root.staticText.lk.actSuccessText,
              closeBthNone: true,
            })
          } else {
            this.openError(data)
          }
        })
        .catch(data => {
          this.disabledForm = false
          this.openError(data)
        })
    },
    openError(data) {
      let text = this.$root.staticText.lk.actErrorText
      if (data.errors && data.errors.length > 0) {
        let key = Object.keys(data.errors)[0]
        if (data.errors[key][0]) {
          text = data.errors[key][0]
        }
      }
      this.modalType_lkErrorOpen({
        title: this.$root.staticText.lk.lkErrorTitle,
        text: text,
        closeBthNone: true,
      })
    },
  },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/templates/components/base/modals/act-request.vue